/**
 * Simple Icon System
 * Sets --icon-url CSS custom property based on data-icon attributes
 */

function initIcons() {
  const iconElements = document.querySelectorAll('[data-icon]');

  // Get the base path from WordPress (fallback for local development)
  const basePath = window.alloyTheme?.iconBasePath || '/icons/';

  iconElements.forEach(element => {
    const iconName = element.dataset.icon;
    if (iconName) {
      element.style.setProperty('--icon-url', `url("${basePath}${iconName}.svg")`);
    }
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initIcons);

// Export for manual use if needed
window.initIcons = initIcons; 